export default __webpack_public_path__ + "static/media/Audio-Number-15.4b25f807.mp3";